import {Component, Input, OnInit} from '@angular/core';
import {ComponentAsElement} from '../../services/common/bootstrap/annotation/component-as-element';
import {CartService} from "../../services/cart.service"

@ComponentAsElement('v-cart-summary-element')
@Component({
  selector: 'v-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: []
})
export class CartSummaryComponent implements OnInit {
  @Input() isInsuranceCouponApplied: boolean;
  @Input() asmMode: string;
  summary;

  constructor(private cartService: CartService) {}

  ngOnInit() {
    this.cartService.cartTotal.subscribe(_cartTotal => {
      this.summary = _cartTotal;
    });
  }
}
